"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SkeletonItem", {
    enumerable: true,
    get: function() {
        return SkeletonItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSkeletonItem = require("./useSkeletonItem");
const _renderSkeletonItem = require("./renderSkeletonItem");
const _useSkeletonItemStylesstyles = require("./useSkeletonItemStyles.styles");
const SkeletonItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSkeletonItem.useSkeletonItem_unstable)(props, ref);
    (0, _useSkeletonItemStylesstyles.useSkeletonItemStyles_unstable)(state);
    return (0, _renderSkeletonItem.renderSkeletonItem_unstable)(state);
});
SkeletonItem.displayName = 'SkeletonItem';
